/* eslint-disable no-bitwise */
import {
  V3StartUp,
  V3VoltageProtection,
  V3FrequencyProtection,
  V3DCIProtection,
  V3OverVoltageUnderVoltageDerate,
  V3OverFrequencyUnderFrequencyDerate,
  V3ReactivePower,
  V3VRTConfig,
  V3IslandConfig,
} from 'ngx-modbus';

import { LeanFormSchema, fieldRef, bitToggleRef, bitSelectRef, SelectOption } from '../types/config-form.types';

// ============ V3StartUp ============

export const SAFETY_STARTUP_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-startup',
  name: 'Pre-Start Up Configuration',
  sections: [{
    id: 'startup',
    labelKey: 'safetyPreStartUpConfiguration',
    registerTable: 'V3StartUp',
    writeBlockSize: 64,
    fields: [
      fieldRef(V3StartUp, 'ConnectWaitTime'),
      fieldRef(V3StartUp, 'PowerUpSpeed'),
      fieldRef(V3StartUp, 'ReconnectWaitTime'),
      fieldRef(V3StartUp, 'ReconnectPowerUpSpeed'),
      fieldRef(V3StartUp, 'VoltHighLimit'),
      fieldRef(V3StartUp, 'VoltLowLimit'),
      fieldRef(V3StartUp, 'FreqHighLimit'),
      fieldRef(V3StartUp, 'FreqLowLimit'),
      fieldRef(V3StartUp, 'ReconnectVoltHighLimit'),
      fieldRef(V3StartUp, 'ReconnectVoltLowLimit'),
      fieldRef(V3StartUp, 'ReconnectFreqHighLimit'),
      fieldRef(V3StartUp, 'ReconnectFreqLowLimit'),
    ],
  }],
};

// ============ V3VoltageProtection ============

export const SAFETY_VOLTAGE_PROTECTION_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-voltage-protection',
  name: 'Voltage Protection',
  sections: [{
    id: 'voltage-protection',
    labelKey: 'safetyVoltageProtection',
    registerTable: 'V3VoltageProtection',
    writeBlockSize: 64,
    fields: [
      fieldRef(V3VoltageProtection, 'RatedVoltage'),
      // OV1
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 0, { labelKey: 'firstOvervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'FirstOvervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VoltageProtection, 'FirstOvervoltageProtectionTime', {

        visibleWhen: { field: 'VoltageConfig_bit0', operator: 'eq', value: 1 },
      }),
      // OV2
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 1, { labelKey: 'secondOvervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'SecondOvervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VoltageProtection, 'SecondOvervoltageProtectionTime', {

        visibleWhen: { field: 'VoltageConfig_bit1', operator: 'eq', value: 1 },
      }),
      // OV3
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 2, { labelKey: 'thirdOvervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'ThirdOvervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VoltageProtection, 'ThirdOvervoltageProtectionTime', {

        visibleWhen: { field: 'VoltageConfig_bit2', operator: 'eq', value: 1 },
      }),
      // UV1
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 3, { labelKey: 'firstUndervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'FirstUndervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit3', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VoltageProtection, 'FirstUndervoltageProtectionTime', {

        visibleWhen: { field: 'VoltageConfig_bit3', operator: 'eq', value: 1 },
      }),
      // UV2
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 4, { labelKey: 'secondUndervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'SecondUndervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VoltageProtection, 'SecondUndervoltageProtectionTime', {

        visibleWhen: { field: 'VoltageConfig_bit4', operator: 'eq', value: 1 },
      }),
      // UV3
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 5, { labelKey: 'thirdUndervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'ThirdUndervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit5', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VoltageProtection, 'ThirdUndervoltageProtectionTime', {

        visibleWhen: { field: 'VoltageConfig_bit5', operator: 'eq', value: 1 },
      }),
      // 10-minute OV
      bitToggleRef(V3VoltageProtection, 'VoltageConfig', 6, { labelKey: 'tenMinOvervoltageProtectionValue' }),
      fieldRef(V3VoltageProtection, 'TenMinOvervoltageProtectionValue', {

        visibleWhen: { field: 'VoltageConfig_bit6', operator: 'eq', value: 1 },
      }),
    ],
  }],
};

// ============ V3FrequencyProtection ============

export const SAFETY_FREQUENCY_PROTECTION_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-frequency-protection',
  name: 'Frequency Protection',
  sections: [{
    id: 'frequency-protection',
    labelKey: 'safetyFrequencyProtection',
    registerTable: 'V3FrequencyProtection',
    writeBlockSize: 64,
    fields: [
      fieldRef(V3FrequencyProtection, 'RatedFrequency'),
      // OF1
      bitToggleRef(V3FrequencyProtection, 'FrequencyConfig', 0, { labelKey: 'firstOverfrequencyProtectionValue' }),
      fieldRef(V3FrequencyProtection, 'FirstOverfrequencyProtectionValue', {

        visibleWhen: { field: 'FrequencyConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3FrequencyProtection, 'FirstOverfrequencyProtectionTime', {

        visibleWhen: { field: 'FrequencyConfig_bit0', operator: 'eq', value: 1 },
      }),
      // OF2
      bitToggleRef(V3FrequencyProtection, 'FrequencyConfig', 1, { labelKey: 'secondOverfrequencyProtectionValue' }),
      fieldRef(V3FrequencyProtection, 'SecondOverfrequencyProtectionValue', {

        visibleWhen: { field: 'FrequencyConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3FrequencyProtection, 'SecondOverfrequencyProtectionTime', {

        visibleWhen: { field: 'FrequencyConfig_bit1', operator: 'eq', value: 1 },
      }),
      // OF3
      bitToggleRef(V3FrequencyProtection, 'FrequencyConfig', 2, { labelKey: 'thirdOverfrequencyProtectionValue' }),
      fieldRef(V3FrequencyProtection, 'ThirdOverfrequencyProtectionValue', {

        visibleWhen: { field: 'FrequencyConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3FrequencyProtection, 'ThirdOverfrequencyProtectionTime', {

        visibleWhen: { field: 'FrequencyConfig_bit2', operator: 'eq', value: 1 },
      }),
      // UF1
      bitToggleRef(V3FrequencyProtection, 'FrequencyConfig', 3, { labelKey: 'firstUnderfrequencyProtectionValue' }),
      fieldRef(V3FrequencyProtection, 'FirstUnderfrequencyProtectionValue', {

        visibleWhen: { field: 'FrequencyConfig_bit3', operator: 'eq', value: 1 },
      }),
      fieldRef(V3FrequencyProtection, 'FirstUnderfrequencyProtectionTime', {

        visibleWhen: { field: 'FrequencyConfig_bit3', operator: 'eq', value: 1 },
      }),
      // UF2
      bitToggleRef(V3FrequencyProtection, 'FrequencyConfig', 4, { labelKey: 'secondUnderfrequencyProtectionValue' }),
      fieldRef(V3FrequencyProtection, 'SecondUnderfrequencyProtectionValue', {

        visibleWhen: { field: 'FrequencyConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3FrequencyProtection, 'SecondUnderfrequencyProtectionTime', {

        visibleWhen: { field: 'FrequencyConfig_bit4', operator: 'eq', value: 1 },
      }),
      // UF3
      bitToggleRef(V3FrequencyProtection, 'FrequencyConfig', 5, { labelKey: 'thirdUnderfrequencyProtectionValue' }),
      fieldRef(V3FrequencyProtection, 'ThirdUnderfrequencyProtectionValue', {

        visibleWhen: { field: 'FrequencyConfig_bit5', operator: 'eq', value: 1 },
      }),
      fieldRef(V3FrequencyProtection, 'ThirdUnderfrequencyProtectionTime', {

        visibleWhen: { field: 'FrequencyConfig_bit5', operator: 'eq', value: 1 },
      }),
    ],
  }],
};

// ============ V3DCIProtection ============

export const SAFETY_DCI_PROTECTION_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-dci-protection',
  name: 'DCI Protection',
  sections: [{
    id: 'dci-protection',
    labelKey: 'safetyDciProtection',
    registerTable: 'V3DCIProtection',
    writeBlockSize: 64,
    fields: [
      // DCI level 1
      bitToggleRef(V3DCIProtection, 'DCIConfig', 0, { labelKey: 'dCIFirstProtectionValue' }),
      fieldRef(V3DCIProtection, 'DCIFirstProtectionValue', {
        visibleWhen: { field: 'DCIConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCIFirstProtectionTime', {

        visibleWhen: { field: 'DCIConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCIFirstProtectionProportion', {

        visibleWhen: { field: 'DCIConfig_bit0', operator: 'eq', value: 1 },
      }),
      // DCI level 2
      bitToggleRef(V3DCIProtection, 'DCIConfig', 1, { labelKey: 'dCISecondProtectionValue' }),
      fieldRef(V3DCIProtection, 'DCISecondProtectionValue', {
        visibleWhen: { field: 'DCIConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCISecondProtectionTime', {

        visibleWhen: { field: 'DCIConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCISecondProtectionProportion', {

        visibleWhen: { field: 'DCIConfig_bit1', operator: 'eq', value: 1 },
      }),
      // DCI level 3
      bitToggleRef(V3DCIProtection, 'DCIConfig', 2, { labelKey: 'dCIThirdProtectionValue' }),
      fieldRef(V3DCIProtection, 'DCIThirdProtectionValue', {
        visibleWhen: { field: 'DCIConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCIThirdProtectionTime', {

        visibleWhen: { field: 'DCIConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCIThirdProtectionProportion', {

        visibleWhen: { field: 'DCIConfig_bit2', operator: 'eq', value: 1 },
      }),
      // DCI testing
      bitToggleRef(V3DCIProtection, 'DCIConfig', 3, { labelKey: 'dCITestingEnable' }),
      fieldRef(V3DCIProtection, 'DCITestValue1', {
        visibleWhen: { field: 'DCIConfig_bit3', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCITestValue2', {
        visibleWhen: { field: 'DCIConfig_bit3', operator: 'eq', value: 1 },
      }),
      fieldRef(V3DCIProtection, 'DCITestValue3', {
        visibleWhen: { field: 'DCIConfig_bit3', operator: 'eq', value: 1 },
      }),
    ],
  }],
};

// ============ V3OverVoltageUnderVoltageDerate (4 sub-sections) ============

export const SAFETY_ACTIVE_DERATE_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-active-derate',
  name: 'Active Power Derate for Grid Over-Voltage',
  sections: [{
    id: 'active-derate',
    labelKey: 'safetyActivePowerDeratingForGridOverVoltage',
    registerTable: 'V3OverVoltageUnderVoltageDerate',
    writeBlockSize: 64,
    fields: [
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 2, { labelKey: 'powerDerateLeadingByHighACVoltage' }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'GridVoltageDropStart', {

        visibleWhen: { field: 'RemoteConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'GridVoltageDropStop', {

        visibleWhen: { field: 'RemoteConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'GridVoltageDropMinPower', {
        visibleWhen: { field: 'RemoteConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'OvervoltageDownSpeed', {
        visibleWhen: { field: 'RemoteConfig_bit2', operator: 'eq', value: 1 },
      }),
      // Battery charging derate by high voltage
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 3, { labelKey: 'batteryChargingPowerDerateLeadingHighVoltage' }),
      // Battery charging derate by low voltage
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 4, { labelKey: 'batteryChargingPowerDerateByLowVoltage' }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'ChgDerateVoltStart', {

        visibleWhen: { field: 'RemoteConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'ChgDerateVoltEnd', {

        visibleWhen: { field: 'RemoteConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'ChgDerateMinPower', {
        visibleWhen: { field: 'RemoteConfig_bit4', operator: 'eq', value: 1 },
      }),
      // Anti-backflow overload
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 7, { labelKey: 'antiBackflowOverloadEnable' }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'RefluxPower', {
        visibleWhen: { field: 'RemoteConfig_bit7', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'RefluxOVloadTime', {

        visibleWhen: { field: 'RemoteConfig_bit7', operator: 'eq', value: 1 },
      }),
      // Voltage PT curve
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 8, { labelKey: 'voltageDropoutPTCurveEnable' }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'VoltageDerateResponseTime', {
        visibleWhen: { field: 'RemoteConfig_bit8', operator: 'eq', value: 1 },
      }),
    ],
  }],
};

export const SAFETY_ACTIVE_POWER_LIMIT_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-active-power-limit',
  name: 'Active Power Limit',
  sections: [{
    id: 'active-power-limit',
    labelKey: 'safetyActivePowerLimit',
    registerTable: 'V3OverVoltageUnderVoltageDerate',
    writeBlockSize: 64,
    fields: [
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 0, { labelKey: 'activeOutputLimit' }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'ActiveOutputLimit', {

        visibleWhen: { field: 'RemoteConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'ActiveOutputDownSpeed', {
        visibleWhen: { field: 'RemoteConfig_bit0', operator: 'eq', value: 1 },
      }),
      // Remote on/off
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 1, { labelKey: 'remoteOnOffControl' }),
    ],
  }],
};

export const SAFETY_DRM0_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-drm0',
  name: 'DRM0',
  sections: [{
    id: 'drm0',
    labelKey: 'safetyDRM0',
    registerTable: 'V3OverVoltageUnderVoltageDerate',
    writeBlockSize: 64,
    fields: [
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 5, { labelKey: 'dRM0' }),
    ],
  }],
};

export const SAFETY_DRM1_8_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-drm1-8',
  name: 'Logic Interface DRM1-8',
  sections: [{
    id: 'drm1-8',
    labelKey: 'safetyLogicInterfaceDRM1_8',
    registerTable: 'V3OverVoltageUnderVoltageDerate',
    writeBlockSize: 64,
    fields: [
      bitToggleRef(V3OverVoltageUnderVoltageDerate, 'RemoteConfig', 6, { labelKey: 'logicInterface' }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic1', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic2', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic3', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic4', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic5', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic6', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic7', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'PowerForLogic8', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'LogicDerateSpeed', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverVoltageUnderVoltageDerate, 'LogicReloadSpeed', {
        visibleWhen: { field: 'RemoteConfig_bit6', operator: 'eq', value: 1 },
      }),
    ],
  }],
};

// ============ V3OverFrequencyUnderFrequencyDerate ============

const DERATING_MODE_OPTIONS: SelectOption[] = [
  { value: 0, label: 'slopeMode' },
  { value: 1, label: 'frequencyMode' },
];

export const SAFETY_OVER_FREQ_DERATE_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-over-freq-derate',
  name: 'Over/Under Frequency Derate',
  sections: [{
    id: 'over-freq-derate',
    labelKey: 'safetyOverFrequencyUnderFrequencyDerate',
    registerTable: 'V3OverFrequencyUnderFrequencyDerate',
    writeBlockSize: 64,
    fields: [
      // ── Over-frequency derate (bit0) + slope/range mode ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 0, { labelKey: 'enableHigherFrequencyPowerDerate' }),
      bitSelectRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', [12, 2], {
        labelKey: 'deratingMode',
        constraint: { options: DERATING_MODE_OPTIONS },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencyStart', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencyEnd', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencySlope', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencyResponseDelay', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit0', operator: 'eq', value: 1 },
      }),

      // ── Under-frequency derate (bit1) ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 1, { labelKey: 'enableLowerFrequencyPowerDerate' }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencyStart', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencyEnd', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencySlope', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencyResponseDelay', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit1', operator: 'eq', value: 1 },
      }),

      // ── Over-frequency reload (bit2) ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 2, { labelKey: 'enableHigherFrequencyPowerReload' }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencyReloadDelay', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencyReloadStart', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'OverfrequencyReloadSpeed', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit2', operator: 'eq', value: 1 },
      }),

      // ── Under-frequency reload (bit3) ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 3, { labelKey: 'enableLowerFrequencyPowerReload' }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencyReloadDelay', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit3', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencyReloadStart', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit3', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'UnderfrequencyReloadSpeed', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit3', operator: 'eq', value: 1 },
      }),

      // ── Derate from rated power (bit4) ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 4, { labelKey: 'enableDerateStartFromRatedPower' }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyRecoverMax', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyRecoverMin', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit4', operator: 'eq', value: 1 },
      }),

      // ── Standalone config toggles ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 5, { labelKey: 'enableDeratingSlopeCalculateByCurrentPower' }),
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 7, { labelKey: 'maximumPowerCalculationEnable' }),

      // ── ESS segmentation curve (bit6) ──
      bitToggleRef(V3OverFrequencyUnderFrequencyDerate, 'FrequencyDerateConfig', 6, { labelKey: 'energyStorageSegmentationCurveEnable' }),
      // ESS fields (visible when bit6 = energy storage segmentation)
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverFrequencyStart', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverfrequencyEnd', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverFrequencySlope', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverFrequencyResponseDelay', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverFrequencyReloadDelay', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverfrequencyReloadStart', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverFrequencyReloadSpeed', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderFrequencyStart', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderfrequencyEnd', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderFrequencySlope', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderFrequencyResponseDelay', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderFrequencyReloadDelay', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderfrequencyReloadStart', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderFrequencyReloadSpeed', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSFrequencyRecoverMax', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSFrequencyRecoverMin', {
        visibleWhen: { field: 'FrequencyDerateConfig_bit4', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSOverFrequencyTransition', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
      fieldRef(V3OverFrequencyUnderFrequencyDerate, 'ESSUnderFrequencyTransition', {

        visibleWhen: { field: 'FrequencyDerateConfig_bit6', operator: 'eq', value: 1 },
      }),
    ],
  }],
};

// ============ V3ReactivePower ============

const REACTIVE_MODE_OPTIONS: SelectOption[] = [
  { value: 0, label: 'reactiveMode1' },
  { value: 1, label: 'reactiveMode2' },
  { value: 2, label: 'reactiveMode3' },
  { value: 3, label: 'reactiveMode4' },
  { value: 4, label: 'reactiveMode5' },
  { value: 5, label: 'reactiveMode6' },
];

export const SAFETY_REACTIVE_POWER_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-reactive-power',
  name: 'Reactive Power',
  sections: [{
    id: 'reactive-power',
    labelKey: 'safetyReactivePower',
    registerTable: 'V3ReactivePower',
    writeBlockSize: 64,
    fields: [
      // ── Enable + mode selector (always visible) ──
      bitToggleRef(V3ReactivePower, 'ReactiveConfig', 0, { labelKey: 'enableReactivePower' }),
      bitSelectRef(V3ReactivePower, 'ReactiveConfig', [1, 3], {
        labelKey: 'reactivePowerMode',
        constraint: { options: REACTIVE_MODE_OPTIONS },
        visibleWhen: { field: 'ReactiveConfig_bit0', operator: 'eq', value: 1 },
      }),

      // ── Shared: response period (visible when reactive enabled) ──
      fieldRef(V3ReactivePower, 'ReactiveResponsePeriod', {
        visibleWhen: { field: 'ReactiveConfig_bit0', operator: 'eq', value: 1 },
      }),

      // ── Mode 1: cos φ fixed (bits1_3 === 0) ──
      fieldRef(V3ReactivePower, 'PowerFactor', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 0 },
      }),

      // ── Mode 2: Q fixed (bits1_3 === 1) ──
      fieldRef(V3ReactivePower, 'FixedReactivePercentage', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 1 },
      }),

      // ── Mode 3: cos φ(P) curve (bits1_3 === 2) ──
      fieldRef(V3ReactivePower, 'ReactiveCos1', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactivedynamicValue1', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactiveCos2', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactivedynamicValue2', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactiveCos3', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactivedynamicValue3', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactiveCos4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'ReactivedynamicValue4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'LockinV', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),
      fieldRef(V3ReactivePower, 'LockoutV', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 2 },
      }),

      // ── Mode 4: Q(Vac) curve (bits1_3 === 3) ──
      fieldRef(V3ReactivePower, 'HighVoltStartValue4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'HighVoltEndValue4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'LowVoltStartValue4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'LowVoltEndValue4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'LockinPower4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'LockoutPower4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'MaxLeadingReactivePower4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'MaxLaggingReactivePower4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'ReactiveResponseWaitTime4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'ReactivePowerOffset4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),
      fieldRef(V3ReactivePower, 'ReactivePowerStart4', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 3 },
      }),

      // ── Mode 5 (bits1_3 === 4) ──
      fieldRef(V3ReactivePower, 'HighVoltStartValue5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'HighVoltEndValue5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'LowVoltStartValue5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'LowVoltEndValue5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'LockinPower5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'LockoutPower5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'MaxReactivePower5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),
      fieldRef(V3ReactivePower, 'ReactiveResponseWaitTime5', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 4 },
      }),

      // ── Mode 6 (bits1_3 === 5) ──
      fieldRef(V3ReactivePower, 'PhaseType', {
        visibleWhen: { field: 'ReactiveConfig_bits1_3', operator: 'eq', value: 5 },
      }),
    ],
  }],
};

// ============ V3VRTConfig (Voltage Ride-Through) ============

const VRT_CURRENT_CALC_MODE_OPTIONS: SelectOption[] = [
  { value: 0, label: 'vRTCalcModeInvalid' },
  { value: 1, label: 'vRTCalcModeDIN4110' },
];

export const SAFETY_VRT_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-vrt',
  name: 'Voltage Ride-Through',
  sections: [{
    id: 'vrt',
    labelKey: 'safetyVoltageRideThrough',
    registerTable: 'V3VRTConfig',
    writeBlockSize: 64,
    fields: [
      // ── LVRT (Low Voltage Ride-Through) ──
      bitToggleRef(V3VRTConfig, 'VRTConfig', 0, { labelKey: 'lVRTEnable' }),
      fieldRef(V3VRTConfig, 'LvrtInVolt', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtFirstPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtFirstPointTime', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtSecondPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtSecondPointTime', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtThirdPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtThirdPointTime', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtFourthPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtFourthPointTime', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtReactiveCurrentCoefficientK', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtWaitingTimeAfterVoltageRecovery', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtPowerBackRate', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtOutVolt', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'LvrtIqVoltStart', {
        visibleWhen: { field: 'VRTConfig_bit0', operator: 'eq', value: 1 },
      }),

      // ── OVRT (Over Voltage Ride-Through) ──
      bitToggleRef(V3VRTConfig, 'VRTConfig', 1, { labelKey: 'oVRTEnable' }),
      fieldRef(V3VRTConfig, 'OvrtInVlot', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtFirstPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtFirstPointTime', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtSecondPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtSecondPointTime', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtThirdPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtThirdPointTime', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtFourthPointVolt', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtFourthPointTime', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtReactiveCurrentCoefficientK', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtWaitingTimeAfterVoltageRecovery', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtPowerBackRate', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtOutVolt', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'OvrtIqVoltStart', {
        visibleWhen: { field: 'VRTConfig_bit1', operator: 'eq', value: 1 },
      }),

      // ── Zero Current Mode ──
      bitToggleRef(V3VRTConfig, 'VRTConfig', 2, { labelKey: 'zeroCurrentModeEnable' }),
      fieldRef(V3VRTConfig, 'ZeroCurrentModeInLowVolt', {
        visibleWhen: { field: 'VRTConfig_bit2', operator: 'eq', value: 1 },
      }),
      fieldRef(V3VRTConfig, 'ZeroCurrentModeInHighVolt', {
        visibleWhen: { field: 'VRTConfig_bit2', operator: 'eq', value: 1 },
      }),

      // ── General VRT config (standalone toggles, no dependent fields) ──
      bitToggleRef(V3VRTConfig, 'VRTConfig', 3, { labelKey: 'keepReactiveCurrentBeforeVRT' }),
      bitToggleRef(V3VRTConfig, 'VRTConfig', 4, { labelKey: 'calcCurrentUsingVoltageBeforeDrop' }),
      bitToggleRef(V3VRTConfig, 'VRTConfig', 5, { labelKey: 'negativeSequenceCurrentEnable' }),
      bitToggleRef(V3VRTConfig, 'VRTConfig', 6, { labelKey: 'highThroughActivePowerEnable' }),
      bitToggleRef(V3VRTConfig, 'VRTConfig', 7, { labelKey: 'lowThroughActivePowerEnable' }),
      bitSelectRef(V3VRTConfig, 'VRTConfig', [8, 4], {
        labelKey: 'vRTCurrentCalcMode',
        constraint: { options: VRT_CURRENT_CALC_MODE_OPTIONS },
      }),
      fieldRef(V3VRTConfig, 'MaxIqPct'),
    ],
  }],
};

// ============ V3IslandConfig (Island, GFCI, ISO) ============

export const SAFETY_ISLAND_FORM: LeanFormSchema = {
  version: '1',
  id: 'safety-island',
  name: 'Island, GFCI, ISO',
  sections: [{
    id: 'island-gfci-iso',
    labelKey: 'safetyIslandGfciIso',
    registerTable: 'V3IslandConfig',
    writeBlockSize: 64,
    fields: [
      bitToggleRef(V3IslandConfig, 'IslandConfig', 0, { labelKey: 'islandingEnable' }),
      bitToggleRef(V3IslandConfig, 'IslandConfig', 1, { labelKey: 'singlePhaseIslandingEnable' }),
      fieldRef(V3IslandConfig, 'IslandDetectSensitivity'),
      bitToggleRef(V3IslandConfig, 'GFCIConfig', 0, { labelKey: 'gFCIEnable' }),
      fieldRef(V3IslandConfig, 'GFCILimit', {
        visibleWhen: { field: 'GFCIConfig_bit0', operator: 'eq', value: 1 },
      }),
      bitToggleRef(V3IslandConfig, 'ISOConfig', 0, { labelKey: 'insulationResistanceEnable' }),
      bitToggleRef(V3IslandConfig, 'ISOConfig', 1, { labelKey: 'groundDetectionEnable' }),
      fieldRef(V3IslandConfig, 'InsulationProtectionValue', {
        visibleWhen: { field: 'ISOConfig_bit0', operator: 'eq', value: 1 },
      }),
      fieldRef(V3IslandConfig, 'IsoLeakageCurrentLimit', {
        visibleWhen: { field: 'ISOConfig_bit0', operator: 'eq', value: 1 },
      }),
      bitToggleRef(V3IslandConfig, 'PE_N_Config', 0, { labelKey: 'pENShortCircuitEnable' }),
      bitToggleRef(V3IslandConfig, 'PE_N_Config', 1, { labelKey: 'nLineDetectionEnable' }),
      fieldRef(V3IslandConfig, 'PEProtectionValue'),
    ],
  }],
};

// ============ Exports ============

export type SafetyFormId =
  | 'safety-startup'
  | 'safety-voltage-protection'
  | 'safety-frequency-protection'
  | 'safety-dci-protection'
  | 'safety-active-derate'
  | 'safety-active-power-limit'
  | 'safety-drm0'
  | 'safety-drm1-8'
  | 'safety-over-freq-derate'
  | 'safety-reactive-power'
  | 'safety-vrt'
  | 'safety-island';

/** All safety form schemas indexed by ID */
export const SAFETY_FORMS: Record<SafetyFormId, LeanFormSchema> = {
  'safety-startup': SAFETY_STARTUP_FORM,
  'safety-voltage-protection': SAFETY_VOLTAGE_PROTECTION_FORM,
  'safety-frequency-protection': SAFETY_FREQUENCY_PROTECTION_FORM,
  'safety-dci-protection': SAFETY_DCI_PROTECTION_FORM,
  'safety-active-derate': SAFETY_ACTIVE_DERATE_FORM,
  'safety-active-power-limit': SAFETY_ACTIVE_POWER_LIMIT_FORM,
  'safety-drm0': SAFETY_DRM0_FORM,
  'safety-drm1-8': SAFETY_DRM1_8_FORM,
  'safety-over-freq-derate': SAFETY_OVER_FREQ_DERATE_FORM,
  'safety-reactive-power': SAFETY_REACTIVE_POWER_FORM,
  'safety-vrt': SAFETY_VRT_FORM,
  'safety-island': SAFETY_ISLAND_FORM,
};
